var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.029 13.3751C7.73221 13.0613 7.73225 12.5704 8.02908 12.2567L11.3303 8.76772C11.7248 8.35077 12.3885 8.35077 12.783 8.76774L15.9709 12.1371C16.2678 12.4509 16.2678 12.9418 15.971 13.2556C15.65 13.5949 15.1098 13.595 14.7888 13.2556L12.7831 11.1355C12.3886 10.7184 11.7247 10.7184 11.3302 11.1354L9.21125 13.3752C8.8902 13.7145 8.35001 13.7145 8.029 13.3751Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.387f84f0270896a7afb8e8fb1152f7e5.svg";
export { ForwardRef as ReactComponent };